<template>
  <div class="main-div premium-public">
    <a class="skip-link" href="#page-content">{{ $t("premium.skipContent") }}</a>
    <nav class="public-nav" :aria-label="$t('premium.mainNavigation')" @keydown.esc="showMenu = false">
      <div class="container public-nav-inner">
        <router-link class="brand" to="/" aria-label="All Care — Home" @click="showMenu = false">
<img class="brand-logo" src="@/assets/logo_allcare.png" width="180" height="60" alt="All Care — Your Shift Hub">
</router-link>
        <button
          class="mobile-menu-toggle"
          type="button"
          :aria-expanded="showMenu"
          aria-controls="public-navigation"
          :aria-label="$t('premium.toggleNavigation')"
          @click="showMenu = !showMenu"
        >
          <i :class="showMenu ? 'fa fa-xmark' : 'fa fa-bars'" aria-hidden="true"></i>
        </button>
        <div id="public-navigation" class="public-navigation" :class="{ 'is-open': showMenu }">
          <div class="public-links">
            <router-link to="/organisations">{{ $t("experience.organisations") }}</router-link>
            <a href="/#about-us" @click="showMenu = false">{{ $t("About us") }}</a><router-link to="/shift-rates" @click="showMenu = false">{{ $t("Shift Rates") }}</router-link><a href="/#get-in-touch" @click="showMenu = false">{{ $t("Get In Touch") }}</a>
          </div>
          <div class="nav-actions">
            <div class="language-changer">
              <label class="visually-hidden" for="public-language">{{ $t("premium.language") }}</label><i class="fa fa-globe" aria-hidden="true"></i><select id="public-language" :value="locale.value" @change="setLocale($event.target.value)">
                <option value="en">EN</option>
                <option value="el">ΕΛ</option>
              </select>
            </div>
            <router-link
              v-if="hasPortalAccess"
              :to="portalLink"
              class="btn btn-primary"
              @click="showMenu = false"
              >
{{ $t("Portal") }} <i class="fa fa-arrow-right" aria-hidden="true"></i>
</router-link>
            <router-link
              v-if="!$store.state.user.loggedIn"
              to="/login"
              class="btn btn-primary"
              @click="showMenu = false"
              >
{{ $t("Log In") }} <i class="fa fa-arrow-right" aria-hidden="true"></i>
</router-link>
            <button v-else class="btn btn-outline-primary" @click="$store.dispatch('signOut')">
              {{ $t("Log Out") }}
            </button>
          </div>
        </div>
      </div>
    </nav>
    <div id="page-content" tabindex="-1">
      <router-view v-slot="{ Component }"><component :is="Component" :key="$route.fullPath.split('#')[0]" /></router-view>
    </div>
    <div v-if="showCookieMessage" class="cookie-message" role="region" :aria-label="$t('premium.cookies')">
      <div>
        {{
          $t(
            "We use cookies to enhance your browsing experience, personalize content, and analyze our traffic."
          )
        }}
        <a target="_blank" rel="noopener" href="/privacy-policy.html">{{ $t("Privacy Policy") }}</a>
      </div>
      <button class="btn btn-primary" @click="acceptCookies()">{{ $t("Got it!") }}</button>
    </div>
    <footer class="public-footer">
      <div class="container">
        <div class="footer-main">
          <div>
            <router-link class="brand" to="/">
<img class="brand-logo" src="@/assets/logo_allcare.png" width="180" height="60" alt="All Care — Your Shift Hub">
</router-link>
            <p>{{ $t("premium.footerTagline") }}</p>
          </div>
          <div>
            <p class="eyebrow">{{ $t("premium.explore") }}</p>
            <a href="/#about-us">{{ $t("About us") }}</a><router-link to="/shift-rates">{{ $t("Shift Rates") }}</router-link><a href="/privacy-policy.html">{{ $t("Privacy Policy") }}</a>
          </div>
          <div>
            <p class="eyebrow">{{ $t("Contact us") }}</p>
            <a href="tel:+35794099400">+357 94 099400</a><a href="mailto:info@allcare.com.cy">info@allcare.com.cy</a>
            <div class="social-links">
              <a
                href="https://www.facebook.com/profile.php?id=61552681300035"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                ><i class="fa-brands fa-facebook" aria-hidden="true"></i></a><a
                href="https://www.instagram.com/allcare.cyprus/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                ><i class="fa-brands fa-instagram" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <span>© {{ year }} All Care Cyprus</span><span>{{ $t("All Cyprus, one network") }}</span>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: "TopLayout",
  data() {
    return {
      year: new Date().getFullYear(),
      showMenu: false
    }
  },
  computed: {
    locale() {
      return { value: this.$store.state.locale === "el" || this.$store.state.locale === "gr" ? "el" : "en" }
    },
    showCookieMessage() {
      return !this.$store.state.acceptedCookies
    },
    portalLink() {
      const routes = { SYSTEM_USER: "/dashboard", EMPLOYEE: "/find-a-shift", CLIENT: "/requests" }
      return routes[this.$store.state.user.claims?.role] || ""
    },
    hasPortalAccess() {
      return Boolean(this.portalLink)
    }
  },
  watch: {
    "$route.fullPath"() {
      this.showMenu = false
    }
  },
  methods: {
    acceptCookies() {
      this.$store.dispatch("acceptCookies")
    },
    setLocale(locale) {
      this.$i18n.locale = locale
      this.$store.dispatch("setLocale", locale)
      this.$moment.locale(locale)
    }
  }
}
</script>
